/*
 *
 * GenericModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 09-Sep-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import formattedMessage from './languageModule'
import componentConfig from '../../modules/componentConfig'

const InformativeISPModal = (props) => {
  const isIamDoubleVerifyPhone = componentConfig.changePhoneNumber.iamDoubleVerify.isActive()
  const isIamDoubleVerifyEmail = componentConfig.changeEmail.iamDoubleVerify.isActive()

  const primaryAction = () => {
    switch (props.primaryAction) {
      case 'updateFiscalCode':
        props.actions.doUpdateFiscalCode({ ...props.data })
        break
      case 'updateEmail':
        isIamDoubleVerifyEmail
          ? props.actions.doCheckChangeEmail({ ...props.data })
          : props.actions.doChangeEmail({ ...props.data })
        break
      case 'updatePhone':
        isIamDoubleVerifyPhone
          ? props.actions.doCheckChangePhone({ ...props.data })
          : props.actions.doChangePhone({ ...props.data })
        break
    }

    props.actions.doHidePopup()
  }

  return (
    <Toggle>
      <MerchantModal
        title={formattedMessage.inactiveRefundInformativePageTitle}
        description={formattedMessage.inactiveRefundInformativePageText}
        onClose={() => props.actions.doHidePopup()}
        primaryButtonLabel={formattedMessage.proceed}
        primaryAction={primaryAction}
        primaryButtonLoading={props.isLoading}
      />
    </Toggle>
  )
}

InformativeISPModal.propTypes = {
  isLoading: PropTypes.bool,
  actions: PropTypes.object,
  primaryAction: PropTypes.string,
  data: PropTypes.object
}

InformativeISPModal.defaultProps = {
  isLoading: false,
  actions: {},
  primaryAction: '',
  data: {}
}

export default InformativeISPModal
